function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
let mulberryInitialized = false;	
window.productData = null;	
window.selectedWarranty = null;

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.body.classList.remove('closed_drawer');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        document.body.classList.add('closed_drawer');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
   onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    let product__media_list = $('.product__media-list').data('double_color');
    if (product__media_list == true) {}
    //parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    if($('#main_image').length > 0){
    $('#main_image').find('img').attr("srcset",this.currentVariant.featured_media.preview_image.src);
    }
     var current_val = this.currentVariant.title;
     var current_val_length = this.currentVariant.options.length;
     var tname = current_val;
     if (this.currentVariant.options.length > 1) {
       tname = current_val.replaceAll(' / ', '/').trim();
       var tnametrim = current_val.replaceAll(' / ', '/').trim();
     } else {
       var tname = current_val;
     }
     document.querySelector('.variant-sku').textContent = this.currentVariant.sku;

     $('body').find('.product__media-item').each(function () {
           var img_alt = $(this).attr('data-image_alt');
           var tnametrim = current_val.replaceAll(' / ', '/').trim();
           if (current_val_length > 0) {
             var double_color = $(this).closest('ul').attr('data-double_color');
             if (double_color == 'true') {
               tname = current_val.split(',')[0].replaceAll(' / ', '/');
             } else {
               tname = tnametrim.split(',')[0].replaceAll(' / ', '/');
             }
           }
           if (img_alt.includes(tname)) {
             $(this).removeClass('hidden');
           } else {
             $(this).addClass('hidden');
           }
    });
    if (window.showCase.dimensions && (window.showCase.dimensions[tname])) {
      if(document.getElementById('dimensions-image')) {
        document.getElementById('dimensions-image').style.backgroundImage = "url("+(window.showCase.dimensions[tname] ? window.showCase.dimensions[tname] : window.showCase.dimensions['default']) + ")";
        var new_format_image = document.getElementById('dimensions-image').hasAttribute('data-new_format_image');
        var image = new Image();
        image.src = (window.showCase.dimensions[tname] ? window.showCase.dimensions[tname] : window.showCase.dimensions['default']);
        if(new_format_image) {
          var new_format_image = document.querySelector('#dimensions-image .dimension_img');
          var new_format_image_src = window.showCase.dimensions[tname] ? window.showCase.dimensions[tname] : window.showCase.dimensions['default'];
          new_format_image.setAttribute('src',new_format_image_src);
        }
        image.onload = function () {
          if ((image.src) == "") {
            $('#dimensions-image').hide();
          } else {
            $('#dimensions-image').show();
          }
          var ratio = this.naturalWidth / this.naturalHeight;
          if (ratio < 1.8) {
            document.getElementById('dimensions-image').style.backgroundSize = "auto " + (ratio * 110) + "%";
          }
          if (ratio < 1.1) {
            document.getElementById('dimensions-image').style.height = "450px";
          }
        }
      }
    }
    arrowsMove(this.currentVariant, true); 
    var id = this.currentVariant.id,
          $selector = $('#ProductETA-template--14299979743305__main'),
          $shippingText = $('.product-single__shipping span'),
          $option = $selector.find('option');
    console.log(this.currentVariant);
    console.log(this.currentVariant.available);
      var newDisplay = 'flex';
      if (!this.currentVariant.available) {
        newDisplay = 'none';
      }
// nik | 04142021	
      if(document.querySelector('.product-single__shipping')){
      	document.querySelector('.product-single__shipping').style.display = newDisplay;
      }
      //console.log($option); 
      $option.each(function(){
        var $el = $(this),
            elId = $el.attr('id');

        if (elId == id ) {
          $el.attr('selected', 'selected');
          //$shippingText.text($el.val());
          // nik | 04142021	
          if(document.querySelector('.product-single__shipping')){
              document.querySelector('.product-single__shipping a span').innerHTML = $el.val();
          }

        } else {
          $el.removeAttr('selected');
        }
      });
  }
 updateURL() {
    window.accrueUrlParams =  window.accrueUrlParams ? window.accrueUrlParams : new URLSearchParams(window.location.search);
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
}

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
      
        if (price) price.classList.remove('visibility-hidden');
        
        if(window.preorder_qty[this.currentVariant.id] === false){
          this.toggleAddButton(true, window.variantStrings.soldOut);
          document.getElementById('BIS_trigger') && (
            document.getElementById('BIS_trigger').style.display = 'block'
          );
          document.querySelector('[data-bis-trigger]') && (
            document.querySelector('[data-bis-trigger]').classList.remove('hidden'),
            document.querySelector('[data-bis-trigger]').style.display = 'block'
          );
          
           if(!document.querySelector('[data-bis-trigger]').classList.contains('hidden')){
                slideTimer && window.clearInterval(slideTimer);
            }
          
        }else{
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          document.getElementById('BIS_trigger') && (
            document.getElementById('BIS_trigger').style.display = 'none'
          );
          document.querySelector('[data-bis-trigger]') && (
            document.querySelector('[data-bis-trigger]').classList.add('hidden'),
            document.querySelector('[data-bis-trigger]').style.display = 'none'
          );
           if(document.querySelector('[data-bis-trigger]').classList.contains('hidden')){
                if(typeof slideTimer !== "undefined"){
                  window.clearInterval(slideTimer);  
                }
            }
        }
        
      });
      if(this.currentVariant.available){
        populateFinanceBlock(this.currentVariant, true);
       // arrowsMove(this.currentVariant, true);
        document.getElementById('financeBlock').style.display = "inline-block";
        document.querySelector(".block-container").style.pointerEvents = "auto";
        $("#financeBlock > div.block-container > div:nth-child(5) > ul").show();
        $("#financeBlock > div.block-container > div:nth-child(5),.border-fin1,.fin-text,.border-fin2").show();
        $('.mob_pro_cart').css({'backgroundColor':'#ffce00'});
        $('svg.icon.icon-plus').css({'stroke':'#ffce00'});
        $('#bread-checkout-btn-product').removeClass('hide-no-stock');
      } else {
        populateFinanceBlock(this.currentVariant, true);
        setTimeout(function(){
          $("#financeBlock > div:nth-child(4) > span > span.add-upsell-wrap > button > div").hide();
        }, 2000); 
        document.getElementById('financeBlock').style.display = "inline-block";
        $("#financeBlock > div.block-container > div:nth-child(5) > ul").hide();
        $('.mob_pro_cart').css({'backgroundColor':'rgb(224 224 224 / 43%)'});
        $('svg.icon.icon-plus').css({'stroke':'rgb(224 224 224 / 43%)'});
        $("#financeBlock > div.block-container > div:nth-child(5),.border-fin1,.fin-text,.border-fin2").hide();
        document.querySelector("#financeBlock > div.block-container > div:nth-child(5) > ul > div.low-as > span > dl > div.price__pricing-group > div.price__badges").style.display = "none";
      //  arrowsMove(this.currentVariant, true);
      }     
      let offer = [];
      async function init() {
        
        const getSelectedVariant = (productData, selectedVariantId) => {
          // console.log('mulberry:getSelectedVariant', window.productData);
          
          if (!selectedVariantId) {
            return window.productData.variants[0];
          }
          return window.productData.variants.find(variant => variant.id == selectedVariantId);
        };
        

        let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
        window.productData = response.product;
        
  
        const selectedVariant = getSelectedVariant(window.productData, this.currentVariant.id);
    
        offer = await mulberry.core.getWarrantyOffer({
          id: product.id,
          title: window.productData.title,
          price: selectedVariant.price,
          detail: window.productData
        })
        
        
        if (!mulberryInitialized) {
          window.mulberry.inline.init({
            offers: offer,
            settings: window.mulberry.core.settings,
            selector:".mulberry-inline-container", //"#mulberry-inline",
            onWarrantyToggle: (warranty) => {
              if (warranty.isSelected) {
                window.selectedWarranty = warranty;
                this.selectedWarranty = warranty;
              } else {
                window.selectedWarranty = null;
                this.selectedWarranty = null;
              }
            },
          });

const sleep = (ms) =>
  new Promise(resolve => setTimeout(resolve, ms));
          
          const syncWarrantyQuantities = async (cart) => {
            const secondCart = await mulberryShop.removeDetachedWarranty(cart)
            const finalCart = await mulberryShop.cart.syncQuantities(secondCart)
            return finalCart
          }
          
          window.pdpModal = await mulberry.modal.init({
            offers: offer, 
            settings: mulberry.core.settings,
            onWarrantySelect: async (warranty) => {
                const result = await mulberryShop.getWarrantyVariant(warranty);
                await sleep(500);
                const variantId = location.search.split('=')[1]
                 // await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {variantId: String(variantId)}, warranty);
                 await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {variantId: String(variantId), title: window.productData.title}, warranty);
             
                const res = await fetch('/cart.js')
                const cart = await res.json()
          		const finalCart = await syncWarrantyQuantities(cart)
            
                mulberry.modal.close();
                setTimeout(function(){
                $('.js-drawer-open-right').click();
              }, 500);
              let cartHTML = await fetch('/cart?view=drawer');
              let cartHTMLFinal = await cartHTML.text();
              $('#cart-notification-product').html($(cartHTMLFinal).html());
              const cartNotification = document.querySelector('cart-notification');
              cartNotification.renderContents(cart);
              cartNotification.open();
              mulberryShop.cart.render();
            },
            onWarrantyDecline: async () => {
              mulberry.modal.close();
              // if(window.pdpModal.warranties[0].cost == '0.00') {
              //   const result = await mulberryShop.getWarrantyVariant(window.pdpModal.warranties[0]);
              //   await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product);
              // }
              
              const res = await fetch('/cart.js')
              const cart = await res.json()
              const finalCart = await syncWarrantyQuantities(cart)
              let cartHTML = await fetch('/cart?view=drawer');
              let cartHTMLFinal = await cartHTML.text();
              $('#cart-notification-product').html($(cartHTMLFinal).html());
              const cartNotification = document.querySelector('cart-notification');
              cartNotification.renderContents(cart);
              cartNotification.open();
              mulberryShop.cart.render();
              setTimeout(function(){
                $('.js-drawer-open-right').click();
              }, 500);
            }
          })
          mulberryInitialized = true;
        }
    
        
        mulberry.modal.updateOffer(offer);
        mulberry.inline.updateOffer(offer);
      

        const addToCartButton = document.querySelector('.product-form__submit');
        addToCartButton.addEventListener('click', () => {
          // console.log('mulberry:selectTest', window.selectedWarranty);
          if (!window.selectedWarranty) {
          
          	mulberry.modal.open();
          }
        })
  

        
	     }
      if(mulberryShop?.paths?.shopifyAdapter) {
         try{init.call(this)} catch(err) {}
      }
      document.addEventListener('mulberry-shopify:loaded', () => {
      	init.call(this);
         
	     })
      
      
      document.addEventListener('mulberry-shopify:warranty-added', async function(e) {
        await mulberryShop.cart.render();
      });    
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      $('.eta_shipping_eta').hide();
    } else {
      addButton.removeAttribute('disabled');
      $('.eta_shipping_eta').css("display","flex");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function populateFinanceBlock(variant, display) {
  if (!display) {
    document.querySelector('.mulberry-block').style.display = "none";
    document.getElementById('financeBlock').style.display = "none";
    return
  }
  var checkBread = window.setInterval(function () {
    if (document.getElementById('bread-checkout-btn-product-bread-iframe')) {
      $('#bread-checkout-btn-product').css("height", "25px");
      document.querySelector("#financeBlock > div.block-container > div:nth-child(1) > ul > div.low-as").style.marginBottom = "27px";
      document.querySelector("#bread-checkout-btn-product").style.opacity = "0.0";
      document.querySelector("#bread-checkout-btn-product").style.position = "absolute";
      document.querySelector("#bread-checkout-btn-product").style.maxWidth = "130px";
      document.querySelector("#financeBlock > div.block-container > div:nth-child(1) > ul").style.display = "flex";
      document.querySelector("#financeBlock > div.block-container > div:nth-child(1) > ul").style.paddingTop = "27px";
    }
  }, 50);
  var url = "https://checkout.getbread.com/api/aslowas/calculate";
  var xhr = new XMLHttpRequest();
  xhr.open("POST", url);
  xhr.setRequestHeader("content-type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (document.getElementById('breadprice')) {
        document.getElementById('breadprice').innerHTML = '$' + Math.round(JSON.parse(xhr.responseText).results[0].asLowAs.monthly / 100);
      }
      if (document.querySelector('.mulberry-block')) {
        document.querySelector('.mulberry-block').style.display = "inline-block";
      }
      if (document.getElementById('financeBlock')) {
        document.getElementById('financeBlock').style.display = "inline-block";
      }
    }
  };
  var totalPrice = parseInt(variant.price);
  var data = '{"apiKey":"3fdcf426-578c-4ebc-ba99-fdc58b2c076a","inputs":[{"customTotal":' + totalPrice + '}]}';
  console.log(data);
  xhr.send(data);
}

function blocklink(){
  document.querySelector('.product-form__submit').click();
}

 ///console.log(li_width);

function arrowsMove(variant, display) {
  var gallaryWidth = $('.main-image_video').width();
var li_width = 0;
$('.product__media-list  li:not(.hidden)').each(function() {
  li_width += $(this).innerWidth();
});
  if (window.innerWidth > 749) {
       console.log(li_width+'=='+ gallaryWidth);
    if (li_width >= gallaryWidth) {
      
      $(".thumbnails-slider--active").prepend(`<div class="newbuttonpre"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#424242" fill-rule="evenodd"/></svg></div>`);
      $(".thumbnails-slider--active").prepend(`<div class="newbuttonext"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"/></svg></div>`);


      $('.newbuttonpre').hide();

      document.querySelector(".product__media-list").style.justifyContent = "flex-start";
      document.querySelector(".product__media-list").style.overflowX = "scroll";
      document.querySelector(".product__media-list").style.width = "98.45%";
      if (window.innerWidth > 1499) {
        document.querySelector(".product__media-list").style.width = "97.5%";
      }
      $('.newbuttonext').click(function () {
        var pos = $('.product__media-list').scrollLeft() + 77;
        $('.product__media-list').scrollLeft(pos);
      });

      $('.newbuttonpre').click(function () {
        var pos = $('.product__media-list').scrollLeft() - 77;
        $('.product__media-list').scrollLeft(pos);
      });

      $('.newbuttonpre, .newbuttonext').click(function () {
        var $elem = $('.product__media-list');
        var newScrollLeft = $elem.scrollLeft(),
          width = $elem.outerWidth(),
          scrollWidth = $elem.get(0).scrollWidth;

        if (scrollWidth - newScrollLeft == width) {
          $('.newbuttonext').hide();
        } else {
          $('.newbuttonext').show();
        }

        if (newScrollLeft == 0) {
          $('.newbuttonpre').hide();
        } else {
          $('.newbuttonpre').show();
        }

      });
    } else {
      document.querySelector(".product__media-list").style.justifyContent = "center";
      $('.newbuttonext').hide();
      $('.newbuttonpre').hide();
    }
  }
}

	
	$("#financeBlock > div.block-container > div:nth-child(1) > ul").click(function () {
	  $("div#bread-checkout-btn-product").click();
	});

$('.swatch-element label').hover(function(){
  var varID = $(this).data('variant-id');
  var mostParent = $(this).parents('.grid-view-item__swatches').parent('.card-information__wrapper').parent('.card-information').parent('.card-wrapper').find('.iWishAddColl');
  $(mostParent).each(function(){
    console.log($(this).data('variant'));  
    if($(this).data('variant') == varID){
      $(this).css("display","block");
    }else{
      $(this).css("display","none");
    }
  });
});

console.log('LISTENER BOUND');
  $('body').on('click', '.js-drawer-open-right', function(e) {
   e.preventDefault();
    console.log('LISTENER CLICK');
  $('#cart-notification').toggleClass('active');
  var cartNotification = document.querySelector('cart-notification');
  $.ajax({
    url: '/cart?view=drawer',
    type: 'get'
  }).done(function(cart) {
   // $('body').addClass('expanded');
    $('#cart-notification-product').html($(cart).html());

    let spanIntervalCartNotification = setInterval(function(){
    	if($('#cart-notification-product').find('.datacount').length > 0){    
    		clearInterval(spanIntervalCartNotification);
    		let checkemty = $('#cart-notification-product').find('.datacount').data('count');
            if (checkemty == '') {
              $('[data-cart-count]').text(0);  
            }else{
              $('[data-cart-count]').text(checkemty);
            }
    	}
    }, 1000);
    
    mulberryShop.cart.init();
    mulberryShop.cart.render();  
    
    const boundThis = this
    console.log('mulberrytest');
  });
     
});

$('body').on('click', '.product-form__submit', function(e) {
  //let event = new Event("click");
  setTimeout(() => {
   // $('.js-drawer-open-right').trigger('click'); 
    var aftersubmitcount = $('#CartCount [data-cart-count]').text();
    $('#cart-notification-button [data-cart-count]').text(aftersubmitcount);
    
  }, 2000);
  
  });
function removecartitem(id) {
  var cart_line_item = (id);
  console.log(id);
  $.ajax({
      type: 'POST',
      url:'/cart/change.js',
      data: 'quantity=0&line=' + cart_line_item,
      dataType: 'json',
      success:  function(data) {
          mulberryShop.removeDetachedWarranty(data);
          $.ajax({
              url: '/cart?view=drawer',
              type: 'get'
          }).done(function(data) {
              $('#cart-notification-product').html($(data).html());
              let checkemty = $('#cart-notification-product').find('.datacount').data('count');
              
              if (checkemty == '') {
                  $('[data-cart-count]').text(0);  
              }else{
                $('[data-cart-count]').text(checkemty);
             }
             mulberryShop.cart.init();
             mulberryShop.cart.render();  
          })
          
      }

  });

  // add alert when item removed.
  $('#remove-from-cart-msg').html('Item removed from Bag!').fadeIn();
}

function updatecartitem(quantity, id) {

  var cart_line_item = (id);
  var data = "updates[" + id + "]=" + quantity + "";
 
  $.ajax({
      type: 'POST',
      beforeSend: function() {
          // $('#ajax-loading-image').fadeIn(1000);
      },
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(data) {
         mulberryShop.cart.syncQuantities(data); 
          $.ajax({
              url: '/cart?view=drawer',
              type: 'get'
          }).done(function(data) {
            $('#cart-notification-product').html($(data).html());
            let checkemty = $('#cart-notification-product').find('.datacount').data('count');
          
            if (checkemty == '') {
                $('[data-cart-count]').text(0);  
            }else{
              $('[data-cart-count]').text(checkemty);
           }
            mulberryShop.cart.init();
            mulberryShop.cart.render();  
          })
      },
      //error: addToCartFail,
      complete: function() {
          $('#ajax-loading-image').fadeOut(1000);
      }
  });
}

$("#cart-notification-product").on('click', '.QuantitySelector__Button', function(e) {
  e.preventDefault();
  var btn_id = $(this).data('line-id');
  var current_quantity = $(this).data('quantity');
  updatecartitem(current_quantity, btn_id);

});

var endlessScroll = new Ajaxinate({
  container: '#product-grid',
  pagination: '#AjaxinatePagination',
  method: 'scroll',
  offset: 0,
  loadingText: '<div class="load-more__icon"> </div>'
});
setTimeout(() => {
  $('.product-form__buttons').next().addClass("hidden");   
}, 8000);


if($(window).width() < 749 ){
  $("slider-component .product-grid").flickity({
    pageDots: false,
    cellAlign: 'center',
    contain: true
  });
}
setTimeout(() => {

  if($(window).width() < 749 ){
  // $("slider-component .product-grid").flickity({
  //   pageDots: false,
  //   cellAlign: 'center',
  //   contain: true
  // });

  $(".new-recommendations-products-items").flickity({
    pageDots: false,
    cellAlign: 'center',
    contain: true
  });
}

}, 5000);

setTimeout(() => {
  
  var chekattr = $('.threedy-embed-btn').attr("style");
    if(chekattr == 'visibility: hidden;'){
      $('#desk_media1 li:first-child').css("display","none"); 
    }
}, 2000);

window.abCartComponentVariant = 'inline_radio'
document.addEventListener('mulberry-shopify:warranty-added', async function(e) {
  cartResp = await fetch('/cart.json')
  cartData = await cartResp.json();
  cartHTML = await fetch('/cart?view=drawer');
  cartHTMLFinal = await cartHTML.text();
  // cartHTMLFinal = await cartHTML.json();;
  $('#cart-notification-product').html($(cartHTMLFinal).html());
  await mulberryShop.cart.render();
  var event = jQuery.Event( "force-cart-rerender", [e] );
  $( "body" ).trigger( event );
  
  if(document.location.href.includes('/cart')) {
    currency = cartData.currency
    totalPrice = cartData.total_price / 100.0

    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
    
    formattedPrice = formatter.format(totalPrice)
    $(".cart-subtotal__price > span").text(formattedPrice)
  }
});

document.addEventListener('mulberry-shopify:loaded', () => {
if (window.location.href.indexOf("cart") != -1) {
jQuery.getJSON('/cart.js', function (cart, textStatus) {
  mulberryShop.removeDetachedWarranty(cart)
  .then(res => {
    mulberryShop.cart.syncQuantities(res)
    .then(final => {
      let cart_item_count = parseInt(final.item_count);
      for(let i=0; i<cart.items.length; i++){
        if (cart.items[i].product_id == "6805285732425"){
          cart_item_count = parseInt(cart_item_count) - parseInt(cart.items[i].quantity);
          cart_item_count = cart_item_count + 1;
        }
      }
      $('span[data-cart-count]').text(`${cart_item_count}`)
    })

  })
   });
}
})
$('body').on('click','.Leather_care_section_7 .faq_item .faq_item-question', function(e) {
  $(this).next().slideToggle();
  $(this).parent().toggleClass('open');
});
$('body').on('click','.anchor_link', function(e) {
  e.preventDefault();
  var href = $(this).attr('href');
  var topOffset = $(href).offset().top;
  $("html, body").animate({scrollTop: topOffset},400);
});
$('body').on('click','.main-nav-link', function(e) {
  e.preventDefault();
  window.location.href = $(this).attr('data-href');
});
$(document).ready(function() {
  $(".video_type_data").css({'position':'relative','visibility':'hidden', 'display':'block'});
  $(".video_type_data").removeClass('hidden');
  var videoHeight = $(".video_type_data deferred-media").attr('style');
  $(".video_type_data").addClass('hidden');
  $(".video_type_data").removeAttr('style');
  $('.main-image_video .product__media').attr("style",videoHeight);

});
